import React from "react";

import BaseApp from "@apps/base/BaseApp";
import {createRoot} from "react-dom/client";

import {setConsumerHeader} from "@globals/utils/setConsumerHeader";

import {AccessRightFlags, CheckAccess} from "@components/CheckAccess";

import SamlConfigurationApp from "./SamlConfigurationApp";

setConsumerHeader();

const root = createRoot(document.getElementById("root")!);

root.render(
  <BaseApp>
    <CheckAccess flag={AccessRightFlags.Authorized} redirectTo="/login/">
      <SamlConfigurationApp />
    </CheckAccess>
  </BaseApp>
);
